export const QUERY_KEYS = {
  MOVIES: "movies",
  MOVIE_DETAILS: "movieDetails",
};

export const QUERY_PARAM_KEYS = {
  SEARCH_ITEM: "search_item",
  YEAR: "year",
  TYPE: "type",
  PAGE: "page",
};
